import {NgModule, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {CommonComponentsModule} from '../../common-components.module';
import {FieldsModule} from '../../components/fields/fields.module';
import {AdminService} from '../../services/admin.service';
import {ThemeListComponent} from './themes/theme-list.component';
import {ThemeModalComponent} from './themes/modal/theme-modal.component';
import {CompanyViewComponent} from './management-company/company-view/company-view.component';
import {CompanyModalComponent} from './management-company/company-modal/company-modal.component';
import {OfficeModalComponent} from './management-company/office-modal/office-modal.component';
import {HintComponent} from './themes/hint/hint.component';
import {ManagementCompanyComponent} from './management-company/management-company.component';
import {ManagementCompanyService} from './management-company/services/management-company.service';
import {ActionButtonComponent} from './management-company/company-view/action-button/action-button.component';
import {PropertyComponent} from './property/property.component';
import {ItemViewComponent} from './property/item-view/item-view.component';
import {PropertyService} from './property/services/property.service';
import { ServicesViewComponent } from './property/item-view/services-view/services-view.component';
import { AmenitiesViewComponent } from './property/item-view/amenities-view/amenities-view.component';
import { PropertyInfoViewComponent } from './property/item-view/property-info-view/property-info-view.component';
import { PropertyModalComponent } from './property/property-modal/property-modal.component';
import { UserRoleComponent } from './user-role/user-role.component';
import { UserRoleItem } from './user-role/item-view/item-view.component';
import { CreateModalComponent } from './user-role/create-modal/create-modal.component';
import { UserRoleService } from './user-role/services/user-role.service';
import { UserComponent } from './user/user.component';
import { UserService } from './user/services/user.service';
import { UserFilterComponent } from './user/user-filter/user-filter.component';
import { BuildingsComponent } from './user/buildings/buildings.component';
import {ActionButtonComponent as UserActionButtonComponent} from './user/action-button/action-button.component';
import { UserModalComponent } from './user/modal/modal.component';
import { PropertiesSelectComponent } from './user/properties-select/properties-select.component';
import {AngularMultiSelectModule} from '../../components/angular2-multiselect-dropdown/multiselect.component';
import {ContactFieldComponent} from './property/item-view/contact-field/contact-field.component';
import { WelcomeMessageModal } from './property/welcome-message-modal/welcome-message-modal.component';
import { SafeHtmlPipeModule } from '../../pipes/safe-html/safe-html-pipe.module';
import {ResetPasswordModalComponent} from './user/reset-password-modal/reset-password-modal.component';
import { PropertyListComponent } from './property/property-list/property-list.component';
import { PropertyGroupListComponent } from './property/property-group-list/property-group-list.component';
import { TabsModule } from '../../components/tabs/tabs.module';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { TabsPropertyModule } from './property/item-view/tabs/tabs-property.module';
import {RelationListComponent} from '../../components/relation-list/relation-list.component';
import {HistoryModalComponent} from './user/history-modal/history-modal.component';
import {AmenityPermissionsViewComponent} from './user-role/amenity-permissions-view/amenity-permissions-view.component';
import {InvitationEmailModalComponent} from 'app/views/admin/property/invitation-email-modal/invitation-email-modal.component';
import {PropertiesFilterComponent} from '../../components/properties-filter/properties-filter.component';
import {AngularMaterialImportModule} from '../../components/angular-material-import-module/angular-material-import.module';
import {AgmCoreModule} from '@agm/core';
import {ConstantsService} from '../../services/constants.service';
import {DeleteUserModalComponent} from 'app/views/admin/user/delete-user-modal/delete-user-modal.component';
import {EditNameModalComponent} from './user/edit-name-modal/edit-name-modal.component';
import {CondomanagerApiService} from '../../services/api/condomanager-api.service';
import {CondomanagerComponent} from './property/condomanager/condomanager.component';
import {SetContactUsModalComponent} from './property/set-contact-us-modal/set-contact-us-modal.component';
import { CorporationDetailedViewComponent } from './property/corporation-detailed-view/corporation-detailed-view.component';
import {NgSelectModule} from '@ng-select/ng-select';
import {UtilsModule} from '../../modules/utils/utils.module';
import {CustomThemeModalComponent} from './property/custom-theme-modal/custom-theme-modal.component';
import {CompanyInvitationEmailModalComponent} from './management-company/company-invitation-email-modal/company-invitation-email-modal.component';

@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        RouterModule,
        CommonComponentsModule,
        FieldsModule,
        TabsModule,
        TabsPropertyModule,
        AngularMultiSelectModule,
        SafeHtmlPipeModule,
        NgMultiSelectDropDownModule,
        AngularMaterialImportModule,
        AgmCoreModule.forRoot({
            apiKey: ConstantsService.googleMapsApiKey
        }),
        NgSelectModule,
        UtilsModule,
    ],
    declarations: [
        PropertyListComponent,
        PropertyGroupListComponent,
        ThemeListComponent,
        ThemeModalComponent,
        CompanyModalComponent,
        CompanyViewComponent,
        OfficeModalComponent,
        HintComponent,
        ManagementCompanyComponent,
        ActionButtonComponent,
        PropertyComponent,
        ItemViewComponent,
        ServicesViewComponent,
        AmenitiesViewComponent,
        PropertyInfoViewComponent,
        PropertyModalComponent,
        UserRoleComponent,
        UserRoleItem,
        CreateModalComponent,
        UserComponent,
        UserFilterComponent,
        BuildingsComponent,
        UserActionButtonComponent,
        UserModalComponent,
        PropertiesSelectComponent,
        ContactFieldComponent,
        WelcomeMessageModal,
        ResetPasswordModalComponent,
        RelationListComponent,
        HistoryModalComponent,
        AmenityPermissionsViewComponent,
        InvitationEmailModalComponent,
        PropertiesFilterComponent,
        DeleteUserModalComponent,
        EditNameModalComponent,
        CondomanagerComponent,
        SetContactUsModalComponent,
        CorporationDetailedViewComponent,
        CustomThemeModalComponent,
        CompanyInvitationEmailModalComponent,
    ],
    providers: [
        CondomanagerApiService,
        AdminService,
        ManagementCompanyService,
        PropertyService,
        UserRoleService,
        UserService
    ],
    exports: [
        WelcomeMessageModal,
        ResetPasswordModalComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AdminModule {
}



// WEBPACK FOOTER //
// /app/src/app/views/admin/admin.module.ts